export default __webpack_public_path__ + "static/media/goshen23.7365e45d.jpg";